import styled from 'styled-components';

export const ContactWrapper = styled.div`
    .text-align-left{
        text-align: left;
    }
`;
